import React, { Component } from 'react';
import Button from '../CommonComponents/Button';
import Modal from '../CommonComponents/Modal';
import SearchBar from '../CommonComponents/SearchBar';
import {
	BASE_URL,
	WEBSOCKET_URL,
	queues,
	ALL_ACTIONS,
	AuxiliaryActions,
} from '../constants';
import {
	api,
	getImage,
	toTitleCase,
	// getTimeDiff,
	getTimeDiffforTransfer,
} from '../utils';
import EndChat from './EndChat';
import { Message, _Queue, MediaMetaType, SocketChat } from './models';
import QueueHistory from './QueueHistory';
import Transfer from './Transfer';
import Menu, { MenuOption } from '../CommonComponents/Menu';
import ReleaseChat from './ReleaseChat';
import { AppContext } from '../Context';
import FileUploadStatusArea from './FileUploadStatusArea';
import refreshImage from '../assets/icons/refresh.svg';

type Props = {
	// chatMarking:boolean;
	setIsBotChatsSelected: (cal: boolean) => void;
	isTakeOverOptedChkFlag: boolean;
	redirectionToLoginPage: Function;
	setNotificationInterval: Function;
	clearNotificationInterval: Function;
	time: string;
	type: string;
	title: string;
	notify: Function;
	botConv: boolean;
	transfer: boolean;
	sessionID: string;
	handoff_id: string;
	ipaddress: string;
	redirectTab: Function;
	getChatMessage: Function;
	botIconUrl: string;
	collectStatus: string;
	isAutoassignedCalled: string;
	tabName: string;
	queueId: number;
	notificationToaster?: Function;
	chatRedirection: Function;
	botId: string;
	customerName: string;
	mappedAgentIds: any;
	botListLength: number;
	tabClicked: number;
	isEndedChatsSelected?: boolean;
	isBotChatsSelected?: boolean;
	getUserDetails: Function;
	showFileUploadIcon: boolean;
	fileUploadStatus: {
		[key: string]: {
			file: {
				name: string;
				status: number;
			};
		};
	};
	updateFileUploadStatus: Function;
	closeFileUploadStatus: Function;
	channel: string;
	deviceInfo: string;
	showTitleNotification: Function;
	showingData: string;
	removeData: Function;
	lang: string;
	phoneNumber: string;
	emailId: string;
	getUserDetailsLoading: Function;
	isShowLoader: boolean;
	noChatsSelected: boolean;
	tenantId: number;
	showScreen: string;
	ischatTab: number;
	getAllBotChats: Function;
	showChats: Function;
	setbotsChatsPage: Function;
	addChats: Function;
	// shownotify: any;
};
type State = {
	dontCall: boolean;
	isButtonDisabled: boolean;
	chats: Message[];
	showUserDetailsLoading: boolean;
	newChat: Message[];
	history: _Queue[];
	isChatLoading: boolean;
	releaseComment: string;
	transferComment: string;
	chatEndingReason: string;
	chatEndingComment: string;
	transferOptionIndex: number;
	isHistoryModalOpen: boolean;
	isReleaseModalOpen: boolean;
	isTransferModalOpen: boolean;
	isChatEndingModalOpen: boolean;
	takeOverCount: number;
	dataFromServer: Message[];
	confirmTakeOver: string;
	disableTakeover: boolean;
	chatMessage: string;
	redirectChat: string;
	startBtnDisable: boolean;
	userDetailsPopup: boolean;
	userName: string;
	userEmail: string;
	userContactNo: string;
	shwUserDetails: boolean;
	endedChatsInfo: {
		customerName: string;
		type: string;
		botName: string;
		botIconUrl: string;
		status: string;
		feedback?: string;
	};
	botChatsInfo: {
		customerName: string;
		type: string;
		botName: string;
		botIconURL: string;
		isTakeOverOptedChkFlag: boolean;
		emailId: string;
		phoneNumber: any;
		channel: string;
		deviceInfo: string;
		session: string;
		ipaddress: string;
		s_id: number;
		time: string;
		title: string;
		tabName: string;
	};
	userSource: string;
	sessionId: string;
	feedbackComment: string;
	time: string;
	deviceInfo: String;
	intervalSetting: any;
	gotitShow: boolean;
	valData: string;
	selectChatObject: any;
	isResolvedShow: boolean;
	// showInvalidate: boolean;
};
// const crypto = require('crypto');

var isdisableTakeOver = false;

export default class Chat extends Component<Props, State> {
	static contextType = AppContext;
	interval: any | number;
	iframeRef: HTMLIFrameElement | null = null;
	socket: WebSocket | undefined;
	usersocket: WebSocket | undefined;
	menuOptions: MenuOption[] = [
		{
			name: 'Transfer chat',
			onClick: this.toggleTransferModal.bind(this, true),
		},
		{
			name: 'Release chat',
			onClick: this.toggleChatReleaseModal.bind(this, true),
		},
	];
	endedChatmenuOptions: MenuOption[] = [
		{
			name: 'See agent & queue history',
			onClick: this.toggleHistoryModal.bind(this, true),
		},
	];
	iframeSrc =
		process.env.NODE_ENV === 'development'
			? 'http://localhost:3000/customer2?source=agent'
			: // : 'https://chatbot.muthoot.org/AwareHybridChat/customer2/index.html?source=agent'; //uat
			  //   'https://hybriduat.senseforth.com/AwareHybridChat/customer2/index.html?source=agent'; //uat
			  //  'https://hybriduat.senseforth.com:8443/AwareHybridChat/customer2/index.html?source=agent'; //newpreprod
			  // 'http://hybridchatprod-env.eba-enbanxts.ap-south-1.elasticbeanstalk.com/AwareHybridChat/customer2/index.html?source=agent';
			  // 'http://13.127.21.132:3000/AwareHybridChat/customer2/index.html?source=agent';
			  // 'http://localhost:3000/AwareHybridChat/customer2/index.html?source=agent';
			  'https://awarehybrid.senseforth.com/Hybrid_PROD_TEST/index.html?source=agent'; //prod

	constructor(props: Props) {
		super(props);
		this.state = this.setInitialState();
		this.endChat = this.endChat.bind(this);
		this.releaseChat = this.releaseChat.bind(this);
		this.transferChat = this.transferChat.bind(this);
		this.setTransferComment = this.setTransferComment.bind(this);
		this.toggleHistoryModal = this.toggleHistoryModal.bind(this);
		this.toggleTransferModal = this.toggleTransferModal.bind(this);
		this.setChatEndingComment = this.setChatEndingComment.bind(this);
		this.toggleChatEndingModal = this.toggleChatEndingModal.bind(this);
		this.setChatReleaseComment = this.setChatReleaseComment.bind(this);
		this.toggleChatReleaseModal = this.toggleChatReleaseModal.bind(this);
		this.transferOptionSelection = this.transferOptionSelection.bind(this);
		this.chatEndingReasonSelection = this.chatEndingReasonSelection.bind(this);
		this.getConversationApi = this.getConversationApi.bind(this);
		this.handleSocketOpened = this.handleSocketOpened.bind(this);
		this.handleSocketClose = this.handleSocketClose.bind(this);
		this.handleOpenFailSocket = this.handleOpenFailSocket.bind(this);
		this.handleEndedChatClick = this.handleEndedChatClick.bind(this);
		this.handleBotChatClick = this.handleBotChatClick.bind(this);
		this.botChatRefreshClick = this.botChatRefreshClick.bind(this);
		this.callRefreshApi = this.callRefreshApi.bind(this);
		this.gotItMarkApi = this.gotItMarkApi.bind(this);
		this.addCall = this.addCall.bind(this);
		this.wsAgentInterventionheartbeat =
			this.wsAgentInterventionheartbeat.bind(this);
		this.websocketEndPointheartbeat =
			this.websocketEndPointheartbeat.bind(this);
		if (this.props.showScreen === 'HybridScreen') {
			// console.log('opening again ');
			this.setupAgentChat();
		}
	}

	componentDidMount() {
		this.setState({
			valData: this.props.showingData,
		});
		document.addEventListener('socketopened', this.handleSocketOpened);
		document.addEventListener('socketClose', this.handleSocketClose);
		document.addEventListener('socketFailOpen', this.handleOpenFailSocket);
		document.addEventListener('endedchatclick', this.handleEndedChatClick);
		document.addEventListener('botchatclick', this.handleBotChatClick);
		api(
			`getInstructionReadStatus?loggedInAgentId=${sessionStorage.getItem(
				'agentId'
			)}&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`
		).then((res) => {
			this.setState({
				gotitShow: res.status,
			});
		});
	}

	gotItMarkApi = (val: boolean) => {
		api(`markInstructionReadStatus`, 'POST', {
			loggedInAgentId: sessionStorage.getItem('agentId'),
			isInstructionRead: val,
			agentSessionID: sessionStorage.getItem('agentActiveSession'),
		}).then((res) => {
			api(
				`getInstructionReadStatus?loggedInAgentId=${sessionStorage.getItem(
					'agentId'
				)}&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`
			).then((res) => {
				this.setState({
					gotitShow: res.status,
					// shwAgentPopup: false,
				});
			});
		});
	};
	handleSocketClose() {
		if (this.socket && this.socket.readyState === WebSocket.OPEN) {
			this.socket.close(1000, 'websocketendpoint closing from UI');
		}
		if (this.usersocket && this.usersocket.readyState === WebSocket.OPEN) {
			this.usersocket.close(1000, 'wsagentintervention closing from UI');
		}
	}

	handleOpenFailSocket() {
		if (sessionStorage.getItem('iswebsocketendpoint') === 'opened') {
			// console.log('Failed wsconnendpoint opened again');
			this.setupAgentChat();
		}
		if (sessionStorage.getItem('iswsagentIntervion') === 'opened') {
			// console.log('Failed wsagentintervention opened again');
			this.setupAgentChatTakeover();
		}
	}

	callRefreshApi() {
		// this.setState({
		//   chats: [],
		//   isChatLoading: true,
		// });
		// this.props.getChatMessage(this.state.chats);

		// this.getConversationApi(
		//   this.state.botChatsInfo.session,
		//   this.state.botChatsInfo.ipaddress,
		//   this.state.botChatsInfo.s_id,
		//   this.state.botChatsInfo.channel,
		//   this.state.botChatsInfo.deviceInfo,
		//   this.state.botChatsInfo.time
		// );
		// this.userDetails();
		this.botChatRefreshClick();
	}

	autoRefresh() {
		this.setState({
			chats: [],
			isChatLoading: true,
		});
		isdisableTakeOver = false;
		this.props.getChatMessage(this.state.chats);
		this.getConversationApi();
	}
	componentDidUpdate(prevProps: Props, prevState: State) {
		// console.log(this.state.endedChatsInfo.customerName)
		if (prevProps.showingData !== this.props.showingData) {
			this.setState({
				endedChatsInfo: {
					customerName: '',
					type: '',
					botName: '',
					botIconUrl: '',
					status: '',
					feedback: '',
				},
			});
			// return;
		}
		// debugger;

		if (
			(prevProps.tabClicked !== this.props.tabClicked &&
				this.props.tabClicked) ||
			(prevProps.sessionID !== this.props.sessionID && this.props.sessionID)
			// ||
			// (prevProps.isEndedChatsSelected !== this.props.isEndedChatsSelected &&
			//   !this.props.isEndedChatsSelected)
		) {
			this.setState({
				chats: [],
				isChatLoading: true,
			});

			if (
				prevProps.isBotChatsSelected !== this.props.isBotChatsSelected &&
				!this.props.isBotChatsSelected
			) {
				// console.log('get inside if part');
				this.setState(
					{
						chats: [],
						isChatLoading: true,
					},
					() => {
						isdisableTakeOver = false;
						this.userDetails();
						//changed below two lines
						this.props.getChatMessage(this.state.chats);
						this.getConversationApi();
					}
				);
			} else {
				if (this.props.ischatTab === 1 || this.props.ischatTab === 0) {
					isdisableTakeOver = false;
					// console.log('get inside else part');
					this.botChatRefreshClick();
				}

				// this.setState(
				//   {
				//     chats: [],
				//     isChatLoading: true,
				//   },
				//   () => {
				//     this.userDetails();
				//     this.getConversationApi(
				//       this.state.botChatsInfo.session,
				//       this.state.botChatsInfo.ipaddress,
				//       this.state.botChatsInfo.s_id,
				//       this.state.botChatsInfo.channel,
				//       this.state.botChatsInfo.deviceInfo,
				//       this.state.botChatsInfo.time
				//     );
				//     this.props.getChatMessage(this.state.chats);
				//   }
				// );
			}
			return; //added
		}

		if (prevProps.sessionID !== this.props.sessionID && !this.props.sessionID) {
			this.setState({
				chats: [],
			});
		}
		if (prevState.chats !== this.state.chats) {
			this.postToIframe({
				chat: this.state.chats.map((chat) => {
					if (chat.message === 'closing') {
						return {
							...chat,
							source: 'agent',
						};
					} else {
						return chat;
					}
				}),
			});
		}
		if (
			this.props.collectStatus === '1' &&
			this.props.isAutoassignedCalled === '0' &&
			prevProps.collectStatus !== this.props.collectStatus
		) {
			this.setChatState(
				'autoassign',
				'',
				this.props.queueId && this.props.queueId,
				-1,
				'',
				false,
				this.props.collectStatus,
				(response: { result: string }) => {
					if (response.result === 'success') {
						console.log('sucess');
					}
				}
			);
		}
	}

	componentWillUnmount() {
		document.removeEventListener('socketopened', this.handleSocketOpened);
		document.removeEventListener('socketClose', this.handleSocketClose);
		document.removeEventListener('socketFailOpen', this.handleOpenFailSocket);
		document.removeEventListener('endedchatclick', this.handleEndedChatClick);
		document.removeEventListener('botchatclick', this.handleBotChatClick);
	}
	handleSocketOpened() {
		if (
			sessionStorage.getItem('wsConnendpoint') === 'open' &&
			sessionStorage.getItem('websocketendpoint') === 'open' &&
			sessionStorage.getItem('autoassignOnLoginCalled') !== 'true'
		) {
			api(`autoassignOnLogin`, 'POST', {
				agentId: sessionStorage.getItem('agentId'),
				agentSessionID: sessionStorage.getItem('agentActiveSession'),
			}).then((res) => {
				sessionStorage.setItem('autoassignOnLoginCalled', 'true');
			});
		}
	}

	// handleSocketOpen() {}
	getConversationApi(
		sessionID?: string,
		ipaddress?: string,
		s_id?: number,
		channel?: string,
		deviceInfo?: string,
		time?: string
	) {
		var newtime; // added for ongoing chats
		if (time === undefined) {
			newtime = '';
		}
		//  if(this.props.isEndedChatsSelected==false){
		//   newtime=this.props.time
		//  }
		else {
			newtime = time;
		}

		if (!isdisableTakeOver) {
			this.setState({
				takeOverCount: 0,
				confirmTakeOver: 'Take Over',
				disableTakeover: false,
			});
		}

		this.setState(
			{
				chats: [],
				isChatLoading: true,
				history: [],
				// showUserDetailsLoading:true
			},
			() => {
				if (this.props.isShowLoader) {
					this.props.getUserDetailsLoading(this.state.showUserDetailsLoading);
				}
			}
		);

		this.setState({
			showUserDetailsLoading: true,
		});

		api(`GetConversation`, 'POST', {
			sessionId: sessionID ? sessionID : this.props.sessionID,
			s_id:
				this.props.isEndedChatsSelected || this.props.isBotChatsSelected
					? s_id
					: this.props.title && this.props.title.split(' ')[2],
			tabName: this.props.isEndedChatsSelected
				? 'Ended Chats'
				: this.state.botChatsInfo.tabName
				? this.state.botChatsInfo.tabName
				: this.props.tabName,
			agentId: sessionStorage.getItem('agentId'),
			ipAddress: ipaddress ? ipaddress : this.props.ipaddress,
			timezoneOffset: new Date().getTimezoneOffset(),
			time: newtime,
			channel:
				this.props.channel !== undefined && this.props.channel === 'whatsapp'
					? this.props.channel
					: channel !== undefined && channel.toLowerCase()
					? channel.toLowerCase()
					: this.props.channel,
			deviceInfo:
				(this.props.channel &&
					this.props.channel.toLowerCase() === 'whatsapp') ||
				channel === 'whatsapp'
					? ''
					: deviceInfo
					? deviceInfo
					: this.props.deviceInfo,
			agentSessionID: sessionStorage.getItem('agentActiveSession'),
		}).then((response) => {
			if (response.error === 'Authentication Failed') {
				this.props.redirectionToLoginPage();
			} else {
				// if (response.redirectToLogin === true) {
				// 	this.props.redirectionToLoginPage();
				// } else {
				// if (response.accessDenied === true) {
				//   this.props.getAllBotChats();
				// }
				sessionStorage.setItem(
					'currentSessionID',
					sessionID ? sessionID : this.props.sessionID
				);
				localStorage.setItem(
					'chatSessionId',
					sessionID ? sessionID : this.props.sessionID
				);
				this.props.closeFileUploadStatus(this.props.sessionID);
				// console.log(sessionStorage.getItem('currentSessionID'));
				this.setState(
					{
						showUserDetailsLoading: false,
						selectChatObject: {
							selected_channel:
								this.props.channel &&
								this.props.channel.toLowerCase() === 'whatsapp'
									? this.props.channel.toLowerCase()
									: channel && channel.toLowerCase()
									? channel.toLowerCase()
									: this.props.channel.toLowerCase(),
							selected_deviceInfo:
								(this.props.channel &&
									this.props.channel.toLowerCase() === 'whatsapp') ||
								channel === 'whatsapp'
									? ''
									: deviceInfo
									? deviceInfo
									: this.props.deviceInfo,
							selected_sessionID: sessionID ? sessionID : this.props.sessionID,
							selected_ipaddress: ipaddress ? ipaddress : this.props.ipaddress,
							selected_botID: this.props.botId,
							selected_queue: this.props.queueId,
						},
					},
					() => {
						this.props.getUserDetailsLoading(this.state.showUserDetailsLoading);
					}
				);
				if (this.props.isEndedChatsSelected === true) {
					api(
						`GetChatTransferHistory?sessionID=${
							this.props.isEndedChatsSelected
								? s_id
								: this.props.title.split(' ')[2]
						}&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`
					).then((response) => {
						if (response.error === 'Authentication Failed') {
							this.props.redirectionToLoginPage();
						} else {
							// if (response.redirectToLogin === true) {
							// 	this.props.redirectionToLoginPage();
							// } else {
							this.setState(
								{
									history: response.resp
										.map((h: any) => {
											const {
												agentID,
												action_time,
												action_feedback,
												conv_action,
												queueName,
											} = h;
											return {
												sentBy: agentID,
												comment: action_feedback,
												time: getTimeDiffforTransfer(action_time),
												chatType: queueName ? toTitleCase(queueName) : '',
												type:
													conv_action === 'reassign'
														? 'transfer'
														: conv_action === 'accept'
														? 'start'
														: conv_action === 'close'
														? 'handoff'
														: conv_action,
											};
										})
										.reverse(),
									// isChatLoading: false,
								},
								() => {}
							);
						}
					});
				}
				this.setState(
					{
						isChatLoading: false,
					},
					() => {}
				);

				const { chat: chats } = response;

				if (chats) {
					// debugger;
					this.addCall(chats);
				}
			}
		});
	}

	addCall(chats: Message[]) {
		this.setState(
			{
				newChat: chats,
			},
			() => {
				this.addChat(this.state.newChat);

				// if (this.props.shownotify === true) {
				//   var lastelem = this.state.newChat.slice(-2);
				//   // var lastPreviousElem = this.state.newChat.slice(-2);

				//   if (lastelem && lastelem[1].source === 'user') {
				//     this.handelCutomerNotification(lastelem[1].message, '');
				//   } else if (
				//     lastelem &&
				//     lastelem[0].message === 'Customer disconnected from the chat'
				//   ) {
				//     this.handelCutomerNotification(lastelem[0].message, '');
				//   }
				// }
			}
		);
	}

	setInitialState(): State {
		return {
			dontCall: false,
			isButtonDisabled: this.props.botConv,
			chats: [],
			history: [],
			releaseComment: '',
			transferComment: '',
			chatEndingReason: '',
			isChatLoading: false,
			chatEndingComment: '',
			transferOptionIndex: -1,
			isHistoryModalOpen: false,
			isReleaseModalOpen: false,
			isTransferModalOpen: false,
			isChatEndingModalOpen: false,
			takeOverCount: 0,
			dataFromServer: [],
			redirectChat: '',
			confirmTakeOver: 'Take Over',
			disableTakeover: false,
			chatMessage: '',
			startBtnDisable: false,
			userDetailsPopup: false,
			userName: '',
			userEmail: '',
			userContactNo: '',
			shwUserDetails: false,
			endedChatsInfo: {
				customerName: '',
				type: '',
				botName: '',
				botIconUrl: '',
				status: '',
				feedback: '',
			},
			botChatsInfo: {
				customerName: '',
				type: '',
				botName: '',
				botIconURL: '',
				isTakeOverOptedChkFlag: false,
				emailId: '',
				phoneNumber: '',
				channel: '',
				deviceInfo: '',
				session: '',
				ipaddress: '',
				s_id: 0,
				time: '',
				title: '',
				tabName: '',
			},
			userSource: '',
			deviceInfo: '',
			feedbackComment: '',
			time: '',
			sessionId: '',
			intervalSetting: '',
			gotitShow: true,
			valData: '',
			newChat: [],
			isResolvedShow: true,
			showUserDetailsLoading: false,
			selectChatObject: {
				selected_channel: '',
				selected_deviceInfo: '',
				selected_sessionID: '',
				selected_ipaddress: '',
				selected_botID: '',
				selected_queue: '',
			},
			// showInvalidate: false,
		};
	}

	setIFrameListener() {
		this.iframeRef = document.querySelector('iframe');
	}

	postToIframe(message: { chat: Message[] }) {
		// console.log(message);
		if (!this.iframeRef) {
			this.setIFrameListener();
		}
		const iframeWindow = this.iframeRef && this.iframeRef.contentWindow;
		iframeWindow && iframeWindow.postMessage(message, '*');
	}

	transferOptionSelection(index: number) {
		this.setState({
			transferOptionIndex: index,
		});
	}

	toggleTransferModal(bool: boolean) {
		this.setState({
			isButtonDisabled: bool,
			isTransferModalOpen: bool,
			transferOptionIndex: -1,
		});

		if (!bool) {
			this.setTransferComment('');
		}
	}

	setTransferComment(text: string) {
		this.setState({
			transferComment: text,
		});
	}

	transferChat() {
		this.setChatState(
			'reassign',
			this.state.transferComment,
			this.state.transferOptionIndex,
			this.props.queueId && this.props.queueId,
			'',
			false,
			this.props.collectStatus,
			(response: { result: string }) => {
				this.toggleTransferModal(false);
				if (response.result === 'success') {
					// this.props.notify(`Chat transferred! Find it under my queues.`);
					this.props.notificationToaster &&
						this.props.notificationToaster(
							'Chat transferred! Find it under my queues.'
						);
					// if (this.props.tabName === 'My Chats') {
					//   this.sendAgentInput(
					//     'Your chat has been transferred. Please stay online while the other agent connects with you',
					//     this.props.sessionID
					//   );
					// }
				}
			}
		);
	}

	toggleHistoryModal(bool: boolean) {
		this.setState({
			isHistoryModalOpen: bool,
		});
	}

	toggleChatEndingModal(bool: boolean) {
		this.setState({
			isChatEndingModalOpen: bool,
		});

		if (!bool) {
			this.setChatEndingComment('');
		}
	}

	chatEndingReasonSelection(reason: string) {
		this.setState({
			chatEndingReason: reason,
		});
	}

	setChatEndingComment(text: string) {
		this.setState({
			chatEndingComment: text,
		});
	}

	endChat(markedFor: string, endFrom?: boolean) {
		let fetchedVal = document.getElementsByClassName(
			'sf-radio clickable selected'
		);
		let splitedVal = fetchedVal[0].innerHTML.split(' ')[2];
		const queue = queues.find(
			(q) => q.name.toLowerCase() === this.props.type.slice(0, -4)
		);
		this.toggleChatEndingModal(false);
		this.setChatState(
			splitedVal === 'id="resolved"'
				? 'close_resolved'
				: splitedVal === 'id="unresolved"><label'
				? 'close_unresolved'
				: 'close_abandon',
			this.state.chatEndingComment,
			this.props.queueId && this.props.queueId,
			-1,
			markedFor,
			false,
			this.props.collectStatus,
			(response: { result: string }) => {
				if (response.result === 'success') {
					this.props.notificationToaster &&
						this.props.notificationToaster(endFrom ? endFrom : 'Chat ended');
					this.props.showChats(true);
					setTimeout(() => {
						this.setState({
							isButtonDisabled: false,
						});
					}, 3000);
					this.setState({
						isResolvedShow: false,
					});
					// this.props.notify(`Chat ended! Pick up a new chat.`);
				}
			}
		);
	}

	addChat(input: Message[]) {
		this.setState(
			(prevState) => ({
				chats: [...prevState.chats, ...input],
			}),
			() => {
				// console.log('got in', this.state.chats);
			}
		);

		this.props.getChatMessage(this.state.chats);
	}
	setChatState(
		action:
			| 'accept'
			| 'close_resolved'
			| 'close_abandon'
			| 'close_unresolved'
			| 'reassign'
			| 'release'
			| 'User closing chat'
			| 'autoassign'
			| 'close',
		feedback: string,
		queue: number,
		prevQueueId: number,
		markedFor: string,
		isTakeOver: boolean,
		collectStatus: string,
		callback: (response: { result: string }) => any
	) {
		var data = '';
		if (this.state.selectChatObject.selected_channel === 'webs') {
			data = 'webs';
		} else {
			data = 'whatsapp';
		}
		console.log('get into set history function');
		if (this.socket) {
			if (this.socket.readyState !== WebSocket.OPEN) {
				this.setupAgentChat();
			}
			this.socket.onopen = () => {
				if (this.socket) {
					console.log('sent session to socket');
					this.socket.send(
						JSON.stringify({
							agentSessionID: sessionStorage.getItem('agentActiveSession'),
						})
					);
				}
			};
		}

		this.setLoader(true);
		let requestObj = {
			sessionId: this.state.selectChatObject.selected_sessionID,
			ipAddress: this.state.selectChatObject.selected_ipaddress,
			action: action,
			feedback: feedback,
			queue: queue,
			prevQueueId: prevQueueId,
			agentId: sessionStorage.getItem('agentId'),
			channel: data,
			source: 'agent',
			markedFor: markedFor,
			botId: encodeURIComponent(this.state.selectChatObject.selected_botID),
			isTakeOver: isTakeOver,
			sessionIdFromQueue: localStorage.getItem('frstQueueSessionId'),
			collectStatus: collectStatus ? collectStatus : '0',
			lang: this.props.lang,
			phoneNumber: this.props.phoneNumber,
			agentSessionID: sessionStorage.getItem('agentActiveSession'),
			tenantId: this.props.tenantId,
			timezoneOffset: new Date().getTimezoneOffset(),
		};
		api(`SetHistory`, 'POST', requestObj).then((response) => {
			if (response.error === 'Authentication Failed') {
				this.props.redirectionToLoginPage();
			} else {
				// if (response.redirectToLogin === true) {
				// 	this.props.redirectionToLoginPage();
				// } else {
				callback(response);
				if (response.result === 'success') {
					if (action === 'accept') {
						const newchats: SocketChat[] = JSON.parse(
							JSON.stringify(response.ResponseData)
						);

						var chatData: any = newchats
							.filter((chat: SocketChat) => chat.type !== 'mycon')
							.map((chat: SocketChat) => ({
								type: chat.type,
								botName: chat.botName,
								botConv: chat.BotConv,
								channel: chat.channel,
								deviceInfo: chat.deviceInfo,
								pending: chat.pending,
								sessionID: chat.session,
								name: chat.customerName,
								ipaddress: chat.ipaddress,
								title: 'Cust ID ' + chat.s_id,
								timeDiff: chat.time,
								transfer: chat.isChatHistory,
								botIconURL: chat.botIconURL,
								s_id: chat.s_id,
								collectStatus: chat.collectStatus,
								isAutoassignedCalled: chat.isAutoassignedCalled,
								tabName: chat.tabName,
								queueId: chat.queueId,
								botId: chat.botId,
								customerName: chat.customerName,
								mappedAgentIds: chat.mappedAgentIds,
								botListLength: 0,
								isTransferOrRelease: chat.isTransferOrRelease,
								lastMsg: chat.lastMsg,
								isTyping: !!chat.isTyping,
								lang: chat.lang,
								phoneNumber: chat.phoneNumber,
								emailId: chat.emailId,
								isTakeOverOptedChkFlag: chat.isTakeOverOptedChkFlag,
								calledFrom: 'agent',
							}));
						// console.log(chatData);
						this.props.addChats(chatData);
						this.props.redirectTab(Math.random());

						console.log('redirected');
					}
				} else {
					// if (action === 'accept') {
					//   setTimeout(() => {
					//     console.log('result failed');
					//     this.props.notificationToaster &&
					//       this.props.notificationToaster('chat accepted by another agent');
					//   }, 1000);
					// }
				}
				this.setLoader(false);
			}
		});
	}

	acceptChat() {
		this.setState(
			{
				chats: [],
				isChatLoading: true,
			},
			() => {
				sessionStorage.setItem('startsessionID', this.props.sessionID);
				const queue = queues.find(
					(q) => q.name.toLowerCase() === this.props.type.slice(0, -2)
				);
				this.setChatState(
					'accept',
					'',
					this.props.queueId && this.props.queueId,
					-1,
					'',
					false,
					this.props.collectStatus,
					(response: { result: string }) => {
						if (response.result === 'success') {
							// this.props.notify(`Chat accepted! Find it under my chats.`);
							this.setState({
								startBtnDisable: false,
								isChatLoading: false,
							});
							// this.props.notificationToaster &&
							//   this.props.notificationToaster('Chat started');
							// this.sendAgentInput('Connected with user', this.props.sessionID);
						}
					}
				);
			}
		);
	}
	takeOverChat(val: number, custid: any) {
		sessionStorage.setItem('startsessionID', this.state.botChatsInfo.session);

		if (this.state.takeOverCount === 1) {
			isdisableTakeOver = false;
			console.log('if takeover 1');

			this.setupAgentChatTakeover();
			this.setState({
				takeOverCount: 0,
				confirmTakeOver: 'Take Over',
				disableTakeover: false,
			});
		} else {
			isdisableTakeOver = true;
			if (!this.state.disableTakeover) {
				this.botChatRefreshClick();
			}

			var lastelem = this.state.chats.slice(-1);
			if (
				lastelem &&
				lastelem[0].message === 'Customer session has been expired'
			) {
				console.log('customer session expired');
				this.setState({
					disableTakeover: true,
				});
			} else {
				this.setState(
					{
						disableTakeover: false,
						takeOverCount: this.state.takeOverCount + 1,
						confirmTakeOver: 'Confirm take over from bot',
					},
					() => {
						// console.log('confirm take over', this.state.confirmTakeOver);
					}
				);
			}
			// this.setState({
			//   takeOverCount: this.state.takeOverCount + 1,
			//   confirmTakeOver: 'Confirm take over from bot',
			// });
		}
	}

	whatsaptakeOverChat(val: number, custid: any) {
		sessionStorage.setItem('startsessionID', this.state.botChatsInfo.session);

		if (this.state.takeOverCount === 1) {
			isdisableTakeOver = false;
			// console.log('if take over count 1');
			this.setState(
				{
					takeOverCount: 0,
					confirmTakeOver: 'Take Over',
					isChatLoading: true,
					disableTakeover: false,
				},
				() => {
					this.setChatState(
						'accept',
						'',
						this.props.queueId && this.props.queueId,
						-1,
						'',
						true,
						this.props.collectStatus,
						(response: { result: string }) => {
							if (response.result === 'success') {
								// console.log('whatsapp takeoversuccess');
								this.setState({
									isChatLoading: false,
								});
							}
						}
					);
				}
			);
		} else {
			// this.setState({
			//   takeOverCount: this.state.takeOverCount + 1,
			//   confirmTakeOver: 'Confirm take over from bot',
			// });
			isdisableTakeOver = true;
			if (!this.state.disableTakeover) {
				this.botChatRefreshClick();
			}
			var lastelem = this.state.chats.slice(-1);
			if (
				lastelem &&
				lastelem[0].message === 'Customer session has been expired'
			) {
				this.setState({
					disableTakeover: true,
				});
			} else {
				this.setState({
					disableTakeover: false,
					takeOverCount: this.state.takeOverCount + 1,
					confirmTakeOver: 'Confirm take over from bot',
				});
			}
		}

		// }
	}

	setupAgentChat() {
		this.socket = new WebSocket(
			WEBSOCKET_URL + BASE_URL + '/websocketendpoint' //uat
			// 'wss://' + BASE_URL + '/websocketendpoint'
		);
		this.socket.onopen = () => {
			sessionStorage.setItem('websocketendpoint', 'open');
			sessionStorage.setItem('iswebsocketendpoint', 'opened');
			document.dispatchEvent(new Event('socketopened'));
			this.websocketEndPointheartbeat();
		};
		this.socket.onmessage = this.agentSocketListener.bind(this);

		this.socket.onclose = (ev) => {
			console.log(ev);
		};
	}

	wsAgentInterventionheartbeat() {
		if (!this.usersocket) return;
		if (this.usersocket.readyState !== 1) return;
		this.usersocket.send(JSON.stringify({ keepalive: 'true' }));
		setTimeout(this.wsAgentInterventionheartbeat, 5000);
	}

	websocketEndPointheartbeat() {
		if (!this.socket) return;
		if (this.socket.readyState !== 1) return;
		this.socket.send(JSON.stringify({ keepalive: 'true' }));
		setTimeout(this.websocketEndPointheartbeat, 5000);
	}

	setupAgentChatTakeover() {
		this.usersocket = new WebSocket(
			WEBSOCKET_URL + BASE_URL + '/wsagentintervention' //uat
			// 'wss://' + BASE_URL + '/wsagentintervention'
		);
		// this.agentIntervention(this.props.sessionID);
		this.agentIntervention(this.state.botChatsInfo.session);

		this.usersocket.onmessage = (event) => {
			const data = JSON.parse(event.data);
			//  console.log('recieved',data)
			if (data.action === 'error_in_receiving') {
				console.log('Customer Tab Closed websocket messsage not received');
				//  this.props.notify(`User has left the chat`);
				//Sorry, The chat is no longer is active to take over!
				this.props.notificationToaster &&
					this.props.notificationToaster('User has left the chat');
			} else if (data.action === 'already take over') {
				console.log('Chat Takeover by another agent');
				this.props.notificationToaster &&
					this.props.notificationToaster('Chat Takeover by another agent');
				if (this.usersocket && this.usersocket.readyState === WebSocket.OPEN) {
					this.usersocket.close(1000, 'wsagentintervention is closing from UI');
				}
			} else {
				if (data.openSocket === 'callAPI') {
					this.setState(
						{
							chats: [],
							isChatLoading: true,
						},
						() => {
							console.log('call set sethistory');
							this.setChatState(
								'accept',
								'',
								this.props.queueId && this.props.queueId,
								-1,
								'',
								true,
								this.props.collectStatus,
								(response: { result: string }) => {
									if (response.result === 'success') {
										// console.log('sethistory success');
										this.setState(
											{
												isChatLoading: false,
											},
											() => {
												if (
													this.usersocket &&
													this.usersocket.readyState === WebSocket.OPEN
												) {
													this.usersocket.close(
														1000,
														'wsagentintervention closing from UI'
													);
												}
											}
										);
									}
								}
							);
						}
					);
				}
			}

			return true;
		};

		this.usersocket.onclose = (ev) => {
			console.log(ev);
			if (ev.reason !== 'wsagentintervention closing from UI') {
				this.setupAgentChatTakeover();
			}
			// sessionStorage.setItem('iswsagentIntervion', 'notOpened');
		};
	}

	agentSocketListener(event: MessageEvent) {
		try {
			const {
				message,
				source,
				time,
				convEnd,
				customerName,
				auxAction,
				startAction,
				isMedia,
				disambQuestions,
				mediaMeta,
				tabName,
				sessionId,
				date,
				Invalidate,
			} = JSON.parse(event.data);
			if (Invalidate === true) {
				// this.setState(
				// 	{
				// 		showInvalidate: false,
				// 	},
				// 	() => {
				this.props.redirectionToLoginPage();
				// 	}
				// );
			} else {
				var newMessage = '';
				if (message.trim() !== null && message.trim() !== '') {
					newMessage = message
						.replace(/:/g, ': ')
						.replace(/<(?!br)([^>]+)>/g, '');
				}
				if (sessionId === sessionStorage.getItem('currentSessionID')) {
					// debugger;
					this.setState(
						(prevState) => ({
							chats: [
								...prevState.chats,
								{
									message: convEnd
										? 'Customer disconnected from agent'
										: newMessage,
									source: convEnd ? 'agent' : source,
									// time,
									time,
									auxAction,
									disambQuestions,
									isMedia: isMedia || false,
									mediaMeta: mediaMeta || {},
									date,
								},
							],
							chatMessage: convEnd
								? 'Customer disconnected from agent'
								: newMessage,
						}),
						() => {
							// console.log(sessionId,this.state.chats)
						}
					);
				}

				if (
					auxAction !== AuxiliaryActions.typing &&
					newMessage !== undefined &&
					newMessage !== '' &&
					customerName !== undefined
				) {
					if (sessionStorage.getItem('agentLogin') === 'Login') {
						// if(this.props.chatMarking===false && tabName==="My Queues"){
						//   return;
						// }
						// else{
						if (source === 'user') {
							this.handelCutomerNotification(newMessage, customerName);
						}

						// }
					}
				}
				if (newMessage === 'Connected with user' && startAction === 'normal') {
					this.props.notificationToaster &&
						this.props.notificationToaster('Chat started');
				} else if (
					newMessage === 'Connected with user' &&
					startAction === 'takeover'
				) {
					this.props.notificationToaster &&
						this.props.notificationToaster(
							'Chat accepted! Find it under my chats.'
						);
				} else if (
					newMessage === 'Connected with user' &&
					startAction === 'autoassignment'
				) {
					this.props.notificationToaster &&
						this.props.notificationToaster('New chat under My Chats');
				}
			}
		} catch (err) {
			console.error(err);
		}
	}
	agentIntervention(evt: any) {
		if (this.usersocket) {
			this.usersocket.onopen = () => {
				// on connecting, do nothing but log it to the console
				sessionStorage.setItem('iswsagentIntervion', 'opened');
				if (this.usersocket) {
					var session = '<%= Session["VALUE"] %>';
					this.usersocket.send(
						JSON.stringify({
							action: 'agent_client',
							IPaddress: this.props.ipaddress,
							userSessionId: evt,
							agentSessionId: session,
							openSocket: 'yes',
							calledFrom: 'agent',
						})
					);
					this.wsAgentInterventionheartbeat();
				}
			};
		}
	}
	sendAgentInput(
		message: string,
		sessionId: string,
		auxAction?: string,
		isMedia?: boolean,
		mediaMeta?: MediaMetaType,
		time?: string,
		channel?: string,
		deviceInfo?: string,
		phoneNumber?: string,
		botId?: string,
		queue?: string
	) {
		if (this.socket) {
			this.socket.send(
				JSON.stringify({
					message,
					channel: channel ? channel : this.props.channel,
					deviceInfo: deviceInfo ? deviceInfo : this.props.deviceInfo,
					sessionId: sessionId,
					queue: queue ? queue : this.props.type,
					action: 'agent_client',
					IPaddress: '127.0.0.1',
					time: time ? time : this.props.time,
					agentId: sessionStorage.getItem('agentId'),
					isMedia: isMedia || false,
					mediaMeta: mediaMeta || {},
					auxAction,
					botId: botId ? botId : this.props.botId,
					phoneNumber: phoneNumber ? phoneNumber : this.props.phoneNumber,
					calledFrom: 'agent',
				})
			);
			// console.log(sessionStorage.getItem('currentSessionID'), sessionId);
			if (sessionStorage.getItem('currentSessionID') === sessionId) {
				this.setState((prevState) => ({
					chats: [
						...prevState.chats,
						{
							message,
							source: 'agent',
							time: new Date().toISOString(),
							auxAction,
							isMedia: isMedia || false,
							disambQuestions: [],
							mediaMeta: mediaMeta || {},
							date: '',
						},
					],
				}));
			}

			if (!auxAction) {
				// this.SessionKeepAlive();
			}
		}
		if (message !== '' && auxAction !== AuxiliaryActions.typing) {
			this.props.getChatMessage(this.state.chats);
		}
	}
	showNotification(notificationMessage: string, name?: string) {
		var msg = '';
		if (
			notificationMessage === 'Connected with User' ||
			notificationMessage === 'Connected with user'
		) {
			// msg = 'Connected with ' + name;

			return;
		} else {
			msg = notificationMessage;
		}
		new Notification('Message received', {
			//  body: `${name} says ${notificationMessage}`,
			body: `${msg}`,
		});
		const audio = document.querySelector('#my_auido') as HTMLAudioElement;
		audio.play();
	}

	handelCutomerNotification(message: string, source: string) {
		this.props.clearNotificationInterval();

		if (Notification.permission === 'granted') {
			this.showNotification(message, source);

			this.props.setNotificationInterval(source, 3000);
		} else if (Notification.permission !== 'denied') {
			Notification.requestPermission().then((permission) => {
				if (permission === 'granted') {
					this.showNotification(message, source);
					this.props.setNotificationInterval(source, 3000);
				}
			});
		} else if (Notification.permission === 'denied') {
			this.props.setNotificationInterval(source, 3000);
		}
	}

	setChatReleaseComment(comment: string) {
		this.setState({
			releaseComment: comment,
		});
	}

	toggleChatReleaseModal(bool: boolean) {
		this.setState({
			isReleaseModalOpen: bool,
			releaseComment: '',
		});
	}

	releaseChat() {
		const queue = queues.find(
			(q) => q.name.toLowerCase() === this.props.type.slice(0, -4)
		);
		this.setChatState(
			'release',
			this.state.releaseComment,
			this.props.queueId && this.props.queueId,
			-1,
			'',
			false,
			this.props.collectStatus,
			(response: { result: string }) => {
				this.toggleChatReleaseModal(false);
				if (response.result === 'success') {
					// this.props.notify(`Chat released successfully!`);
					this.props.notificationToaster &&
						this.props.notificationToaster('Chat released');
					// this.sendAgentInput(
					//   'Your chat has been transferred. Please stay online while the other agent connects with you',
					//   this.props.sessionID
					// );
				}
			}
		);
	}

	setLoader(bool: boolean) {
		this.context.dispatch({
			type: ALL_ACTIONS.UPDATE_LOADER_STATE,
			payload: bool,
		});
	}

	get historyStatement(): string {
		if (this.state.history.length) {
			const history = this.state.history[0];
			let statement = '';
			switch (history.type) {
				case 'transfer': {
					statement = `Transferred to ${history.chatType}`;
					break;
				}
				case 'release': {
					statement = 'Released back to queue';
					break;
				}
				case 'start': {
					statement = 'Chat accepted';
					break;
				}
				case 'handoff': {
					statement = 'Chat handed off';
					break;
				}
				default:
					statement = '';
			}
			return `${statement} ${
				this.state.history.length - 1
					? ' + ' + (this.state.history.length - 1) + ' more'
					: ''
			} •`;
		} else {
			return '';
		}
	}

	get overlayClass(): string {
		return !this.props.type
			? 'white'
			: this.state.isChatLoading
			? 'loading'
			: 'none';
	}
	handleTyping = (term: string) => {
		if (term) {
			this.sendAgentInput('', this.props.sessionID, AuxiliaryActions.typing);
		}
	};
	get FinalMenuOptions() {
		return this.props.queueId !== 11111
			? this.menuOptions
			: this.menuOptions.filter((data) => data.name !== 'Release chat');
	}
	get EndedChatMenuOptions() {
		return this.endedChatmenuOptions;
	}
	userDetails(sessionID?: string, handoff_id?: string) {
		if (this.props.isEndedChatsSelected === true) {
			api(
				`getUserDetails?sessionId=${
					sessionID ? sessionID : this.props.sessionID
				}&tabName=${'Ended Chats'}&handoff_id=${
					handoff_id ? handoff_id : this.props.handoff_id
				}&agentSessionID=${sessionStorage.getItem('agentActiveSession')}`
			).then((res) => {
				if (res.error === 'Authentication Failed') {
					this.props.redirectionToLoginPage();
				} else {
					// if (res.redirectToLogin === true) {
					// 	this.props.redirectionToLoginPage();
					// } else {
					this.setState(
						{
							userName: res.userName,
							userEmail: res.userEmail,
							userContactNo: res.userPhoneNumber,
							sessionId: res.sessionId,
							feedbackComment: res.feedbackComment,
							time: res.time,
							userSource: res.channel,
							deviceInfo: res.deviceInfo,
							shwUserDetails:
								res.userEmail || res.userPhoneNumber ? true : false,
						},
						() => {
							// console.log('hi',this.state.userName)
							this.props.getUserDetails(
								this.state.userName,
								this.state.userEmail,
								this.state.userContactNo,
								this.state.userSource,
								this.state.deviceInfo,
								this.state.sessionId,
								this.state.feedbackComment,
								this.state.time
							);
						}
					);
				}
			});
		} else if (this.props.isBotChatsSelected === true) {
			this.setState(
				{
					userName: this.state.botChatsInfo.customerName,
					userEmail: this.state.botChatsInfo.emailId,
					userContactNo: this.state.botChatsInfo.phoneNumber,
					sessionId: this.state.botChatsInfo.session,
					// feedbackComment:res.feedbackComment,
					// time:res.time,
					userSource: this.state.botChatsInfo.channel,
					deviceInfo: this.state.botChatsInfo.deviceInfo,
					shwUserDetails:
						this.state.botChatsInfo.emailId ||
						this.state.botChatsInfo.phoneNumber
							? true
							: false,
				},
				() => {
					this.props.getUserDetails(
						this.state.userName,
						this.state.userEmail,
						this.state.userContactNo,
						this.state.userSource,
						this.state.deviceInfo,
						this.state.sessionId,
						this.state.feedbackComment,
						this.state.time
					);
				}
			);
		} else {
			this.setState(
				{
					userName: this.props.customerName,
					userEmail: this.props.emailId,
					userContactNo: this.props.phoneNumber,
					sessionId: this.props.sessionID,
					// feedbackComment:res.feedbackComment,
					// time:res.time,
					userSource: this.props.channel,
					deviceInfo: this.props.deviceInfo,
					shwUserDetails:
						this.props.emailId || this.props.phoneNumber ? true : false,
				},
				() => {
					this.props.getUserDetails(
						this.state.userName,
						this.state.userEmail,
						this.state.userContactNo,
						this.state.userSource,
						this.state.deviceInfo,
						this.state.sessionId,
						this.state.feedbackComment,
						this.state.time
					);
				}
			);
		}
	}

	handleEndedChatClick(e: Event) {
		const {
			sessionID,
			ipaddress,
			s_id,
			botIconUrl,
			customerName,
			status,
			type,
			feedback,
			botName,
			channel,
			deviceInfo,
			handoff_id,
			time,
		} = (e as CustomEvent).detail;
		// this.userDetails(sessionID);
		this.setState(
			{
				endedChatsInfo: {
					botIconUrl,
					customerName,
					status,
					type,
					feedback,
					botName,
				},
			},
			() => {
				this.getConversationApi(
					sessionID,
					ipaddress,
					s_id,
					channel,
					deviceInfo,
					time
				);
			}
		);

		this.userDetails(sessionID, handoff_id);
	}

	handleBotChatClick(e: Event) {
		const {
			type,
			title,
			pending,
			botName,
			botConv,
			ipaddress,
			botIconURL,
			s_id,
			collectStatus,
			tabName,
			queueId,
			botId,
			customerName,
			isTransferOrRelease,
			lastMsg,
			channel,
			deviceInfo,
			isTyping,
			lang,
			phoneNumber,
			emailId,
			isTakeOverOptedChkFlag,
			session,
			time,
		} = (e as CustomEvent).detail;
		// this.userDetails(sessionID);
		this.setState(
			{
				botChatsInfo: {
					botIconURL,
					customerName,
					type,
					botName,
					isTakeOverOptedChkFlag,
					emailId,
					phoneNumber,
					channel,
					deviceInfo,
					session,
					ipaddress,
					s_id,
					time,
					title,
					tabName,
				},
			},
			() => {
				if (this.props.ischatTab === 2) {
					isdisableTakeOver = false;
					this.setState(
						{
							chats: [],
							isChatLoading: true,
						},
						() => {
							// console.log('botchats clicked getconv');
							this.getConversationApi(
								session,
								ipaddress,
								s_id,
								channel,
								deviceInfo,
								time
							);
							this.userDetails();
						}
					);
				}
				// this.botChatRefreshClick(session, ipaddress, s_id, channel, deviceInfo, time);
			}
		);
	}
	botChatRefreshClick() {
		this.setState(
			{
				chats: [],
				isChatLoading: true,
			},
			() => {
				this.userDetails();
				this.getConversationApi(
					this.state.botChatsInfo.session,
					this.state.botChatsInfo.ipaddress,
					this.state.botChatsInfo.s_id,
					this.state.botChatsInfo.channel,
					this.state.botChatsInfo.deviceInfo,
					this.state.botChatsInfo.time
				);
				this.props.getChatMessage(this.state.chats);
			}
		);
	}
	get isFileUploadStatusVisible() {
		return (
			this.props.tabName === 'My Chats' &&
			this.props.fileUploadStatus[this.props.sessionID]
		);
	}

	render() {
		return (
			<div
				className={`chat-wrapper${
					this.props.noChatsSelected === true ||
					(!this.props.type &&
						this.props.isEndedChatsSelected !== true &&
						this.props.isBotChatsSelected !== true)
						? ' hidden'
						: ''
				}`}>
				{/* {this.props.type ||
        this.state.endedChatsInfo.customerName === '' ||
        this.state.botChatsInfo.customerName === '' ? (
          <div className={`overlay ${this.overlayClass}`}></div>
        ) : null} */}

				{!this.props.type &&
				this.props.isEndedChatsSelected !== true &&
				!this.props.isBotChatsSelected ? null : (
					<div id='header'>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<div style={{ display: 'flex' }}>
								{this.props.isEndedChatsSelected ? (
									<div>
										{this.state.endedChatsInfo.botIconUrl && (
											<img
												src={this.state.endedChatsInfo.botIconUrl}
												alt='bot iconurl'
												style={{ width: '30px', height: '30px' }}
											/>
										)}
									</div>
								) : this.props.isBotChatsSelected ? ( // botchats test
									<div>
										{this.state.botChatsInfo.botIconURL ? (
											<img
												src={this.state.botChatsInfo.botIconURL}
												alt='bot iconurl'
												style={{ width: '30px', height: '30px' }}
											/>
										) : null}
									</div>
								) : (
									<div>
										{this.props.botIconUrl && this.props.botListLength > 1 && (
											<img
												src={this.props.botIconUrl}
												alt='bot iconurl'
												style={{ width: '30px', height: '30px' }}
											/>
										)}
									</div>
								)}
								<div style={{ marginTop: '-3px', marginLeft: '5px' }}>
									<div
										id='agent-chat-title'
										style={{ flexDirection: 'column', alignItems: 'left' }}>
										<div>
											{this.props.isEndedChatsSelected
												? this.state.endedChatsInfo.customerName
												: this.props.isBotChatsSelected //botchats test
												? this.state.botChatsInfo.customerName
												: this.props.customerName}{' '}
										</div>
									</div>
									{/* {console.log(
                    this.props.isBotChatsSelected,
                    this.props.isEndedChatsSelected
                  )} */}
									{this.props.isEndedChatsSelected ? (
										<div className='agent-chat-type'>
											{
												<>
													<span>{this.state.endedChatsInfo.botName}</span>
													<span
														style={
															this.state.endedChatsInfo.botName === null
																? { display: 'none' }
																: {}
														}>
														{' '}
														:
													</span>
													<span>{this.state.endedChatsInfo.type}</span>
												</>
											}
										</div>
									) : this.props.isBotChatsSelected ? (
										//botchats test
										<div className='agent-chat-type'>
											{
												<>
													<span>{this.state.botChatsInfo.botName}</span>
													<span
														style={
															this.state.botChatsInfo.botName === null
																? { display: 'none' }
																: {}
														}>
														{' '}
														:
													</span>
													<span>{this.state.botChatsInfo.type}</span>
												</>
											}
										</div>
									) : (
										<div id='agent-chat-type'>
											Queue:&nbsp;
											{this.props.type.replace(/GS/g, '').replace(/_M/g, '')}
										</div>
									)}

									{this.state.history.length !== 0 &&
									this.state.history[0].comment !== '' &&
									// !this.props.isEndedChatsSelected
									this.props.isEndedChatsSelected === true ? (
										<div
											id='release-details'
											className={!this.state.history.length ? 'hidden' : ''}>
											<img src={getImage('transfer.svg')} alt='transfer' />
											{this.historyStatement}
											<div
												className='clickable'
												onClick={() => {
													this.toggleHistoryModal(true);
												}}>
												See history
											</div>
										</div>
									) : null}
									{this.state.history.length !== 0 &&
									this.state.history[0].comment !== '' &&
									// !this.props.isEndedChatsSelected
									this.props.isEndedChatsSelected === true ? (
										<div
											id='user-request-details'
											className={!this.state.history.length ? 'hidden' : ''}>
											<img src={getImage('comment.svg')} alt='comment' />
											<div style={{ wordBreak: 'break-all' }}>
												{this.state.history.length &&
													this.state.history[0].comment}
											</div>
										</div>
									) : null}
								</div>
							</div>
							<div style={{ marginTop: '-10px' }}>
								{this.state.history.length !== 0 &&
								this.state.history[0].comment !== '' &&
								this.props.isEndedChatsSelected === true ? (
									<Menu
										options={this.endedChatmenuOptions}
										isChatEnded='isChatEnded'
									/>
								) : null}
							</div>
						</div>
						{this.props.isEndedChatsSelected ||
						this.props.collectStatus === '1' ||
						this.props.isBotChatsSelected ? (
							<></>
						) : (
							<div id='chat-controls'>
								<Button
									text={`${
										this.props.tabName === 'My Chats' ? 'End' : 'Transfer'
									} Chat`}
									theme='light'
									disabled={this.props.botConv}
									// disabled= {this.props.tabName === 'Bot Chats'? this.props.botConv : this.state.isButtonDisabled}
									onClick={() => {
										if (this.props.tabName === 'My Chats') {
											this.setState(
												{
													// isButtonDisabled: true
												},
												() => {
													this.toggleChatEndingModal(true);
												}
											);
										} else {
											this.toggleTransferModal(true);
										}
									}}
								/>
								{this.props.tabName === 'My Chats' &&
								this.props.collectStatus !== '1' ? (
									<Menu options={this.FinalMenuOptions} />
								) : null}
							</div>
						)}
					</div>
				)}
				<div
					id='chatbot-wrapper'
					className={
						// !this.props.type
						!this.props.type &&
						this.props.isEndedChatsSelected !== true &&
						!this.props.isBotChatsSelected
							? 'hidden'
							: this.props.isEndedChatsSelected
							? 'ended-chats-selected-wrapper'
							: // :
							// this.state.history.length !== 0 &&
							//   this.state.history[0].comment !== '' &&
							//   this.props.tabName === 'My Chats'
							// ? 'collect-statusandHistory-wrapper'
							this.state.history.length !== 0 &&
							  this.state.history[0].comment !== ''
							? 'collect-History-wrapper'
							: this.props.collectStatus === '1'
							? 'collect-status-wrapper'
							: this.state.shwUserDetails
							? 'user-details-iframe-wrapper'
							: this.state.history.length !== 0 &&
							  this.state.history[0].comment !== ''
							? ''
							: 'iframe-wrapper'
					}>
					<>
						{this.props.type === 'bot' ||
						this.props.tabName === 'My Queues' ||
						this.props.isBotChatsSelected === true ? (
							<div className='overall-refresh-popup'>
								<div
									className='refresh-popup-wrapper'
									style={
										this.state.gotitShow === false
											? { display: 'flex' }
											: { display: 'none' }
									}>
									<span className='tap-to-refresh'>
										Tap refresh to see the latest messages
									</span>
									<span
										className='got-it-click'
										onClick={() => {
											// sessionStorage.removeItem('refresh');
											this.gotItMarkApi(true);
										}}>
										Got it
									</span>
								</div>
								<div
									className='refresh-round-button'
									title='Refresh'
									onClick={() => {
										this.callRefreshApi();
									}}>
									<img
										src={refreshImage}
										style={{
											width: '24px',
											height: '24px',
										}}
										alt='refreshImage'
									/>
								</div>
							</div>
						) : null}
						{/* {console.log(this.state.chats)} */}
						{/* {this.state.showUserDetailsLoading === true ? (
              <div
                className='userdetails-loader'
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  width: '100%',
                  height: 'calc(80vh - 167px)',
                  flexDirection: 'column',
                }}>
                <img src={Loader} alt='loader' className='loader-icon' />
                <span className='loader-content'>Loading details</span>
              </div>
            ) : ( */}
						<iframe
							src={this.iframeSrc}
							className={this.isFileUploadStatusVisible ? 'short' : ''}
							title='bot'
							onLoad={() => {
								// {
								//   this.state.showUserDetailsLoading === true ? (
								//     <div
								//       className='userdetails-loader'
								//       style={{
								//         display: 'flex',
								//         justifyContent: 'center',
								//         alignItems: 'center',
								//         cursor: 'pointer',
								//         width: '100%',
								//         height: 'calc(80vh - 167px)',
								//         flexDirection: 'column',
								//       }}>
								//       <img src={Loader} alt='loader' className='loader-icon' />
								//       <span className='loader-content'>Loading chats...</span>
								//     </div>
								//   ) : (
								this.postToIframe({
									chat: this.state.chats,
								});
								//   );
								// }
							}}></iframe>
						{/* )} */}
					</>
					{this.props.tabName === 'My Chats' &&
					sessionStorage.getItem('currentSessionID') ===
						this.props.sessionID ? (
						<FileUploadStatusArea
							file={
								this.props.fileUploadStatus[this.props.sessionID]
									? {
											...this.props.fileUploadStatus[this.props.sessionID].file,
									  }
									: { name: '', status: 0 }
							}
							closeFileUploadStatus={() =>
								this.props.closeFileUploadStatus(this.props.sessionID)
							}
						/>
					) : null}
				</div>
				{!this.props.type && !this.props.isBotChatsSelected ? null : this.props
						.isEndedChatsSelected ? null : (
					<div
						id='agent-input-wrapper'
						style={
							!this.state.botChatsInfo.isTakeOverOptedChkFlag
								? { border: 0 }
								: {}
						}>
						{this.props.tabName === 'My Chats' ? (
							this.props.collectStatus === '1' ? (
								<div>
									<div
										style={{
											fontSize: '20px',
											marginBottom: '20px',
											fontFamily: 'Open Sans',
										}}>
										Select Status
									</div>
									<EndChat
										onConfirm={this.endChat}
										comment={this.state.chatEndingComment}
										onCommentChange={this.setChatEndingComment}
										onEndReasonSelect={this.chatEndingReasonSelection}
										onCancel={this.toggleChatEndingModal.bind(this, false)}
										source='collectStatus'
										sessionID={this.props.sessionID}
									/>
								</div>
							) : (
								<SearchBar
									value={this.context.sendInput}
									icon='submit'
									placeholder='Send a message'
									showFileUploadIcon={this.props.showFileUploadIcon}
									onEnter={(term: string, ev: any) => {
										console.log(term.trim());
										if (term.trim() !== null && term.trim() !== '') {
											this.sendAgentInput(
												term
													.replace(/:/g, ': ')
													.replace(/<(?!br)([^>]+)>/g, ''),
												this.props.sessionID
											);
											// this.sendAgentInput(term, this.props.sessionID);
										}
									}}
									onInput={(ev: any) => console.log(ev.target.textContent)}
									onFileUploadSuccess={(
										name: string,
										size: number,
										type: string,
										mediaURL: string,
										sessionId: string,
										time: string,
										channel: string,
										deviceInfo: string,
										phoneNumber: string,
										botId: string,
										queue: string
									) => {
										this.sendAgentInput(
											name,
											sessionId,
											undefined,
											true,
											{
												name,
												size,
												type,
												mediaURL,
											},
											time,
											channel,
											deviceInfo,
											phoneNumber,
											botId,
											queue
										);
									}}
									onSearch={this.handleTyping}
									sessionID={this.props.sessionID}
									updateFileUploadStatus={this.props.updateFileUploadStatus}
									closeFileUploadStatus={this.props.closeFileUploadStatus}
									channel={this.props.channel}
									deviceInfo={this.props.deviceInfo}
									phoneNumber={this.props.phoneNumber}
									time={this.props.time}
									botId={this.props.botId}
									queue={this.props.type}
								/>
							)
						) : this.props.type === 'bot' || this.props.isBotChatsSelected ? (
							<>
								{/* {this.state.disableTakeover ? (
                  <div className='disable-takeover'>
                    Take Over has been disabled due to customer session has expired
                  </div>
                ) : null} */}
								{this.state.botChatsInfo.isTakeOverOptedChkFlag ? (
									<Button
										text={
											this.state.disableTakeover
												? 'Customer is no longer active'
												: this.state.confirmTakeOver
										}
										theme={this.state.disableTakeover ? 'red' : 'dark'}
										// disabled={this.state.disableTakeover}
										custId={
											this.state.botChatsInfo.title &&
											this.state.botChatsInfo.title.slice(-4)
										}
										onClick={() => {
											this.state.botChatsInfo.channel &&
											(this.state.botChatsInfo.channel === 'whatsapp' ||
												this.state.botChatsInfo.channel === 'WhatsApp' ||
												this.state.botChatsInfo.channel.toLowerCase() ===
													'whatsapp' ||
												this.state.botChatsInfo.channel === 'whatsApp')
												? this.whatsaptakeOverChat(
														this.state.takeOverCount,
														this.state.botChatsInfo.title &&
															this.state.botChatsInfo.title.split(' ')[2]
												  )
												: this.takeOverChat(
														this.state.takeOverCount,
														this.state.botChatsInfo.title &&
															this.state.botChatsInfo.title.split(' ')[2]
												  );
											// this.props.setbotsChatsPage();
										}}
									/>
								) : null}
							</>
						) : (
							<Button
								text='Start Chat'
								theme='dark'
								onClick={() => {
									this.setState({
										redirectChat: this.props.title,
										startBtnDisable: true,
									});
									this.acceptChat();
								}}
							/>
						)}
					</div>
				)}
				<Modal
					title='Select queue to transfer'
					isOpen={this.state.isTransferModalOpen}
					onClose={() => {
						this.toggleTransferModal(false);
						this.setTransferComment('');
					}}>
					<Transfer
						onTransfer={this.transferChat}
						comment={this.state.transferComment}
						setComment={this.setTransferComment}
						onOptionSelect={this.transferOptionSelection}
						transferTypeIndex={this.state.transferOptionIndex}
						chatBotId={this.props.botId}
						queueName={this.props.type}
						tenantId={this.props.tenantId}
					/>
				</Modal>
				<Modal
					title='Chat’s agent & queue history'
					isOpen={this.state.isHistoryModalOpen}
					onClose={this.toggleHistoryModal}>
					<QueueHistory historyList={this.state.history} />
				</Modal>
				<Modal
					title='Select status'
					isOpen={this.state.isChatEndingModalOpen}
					onClose={this.toggleChatEndingModal}>
					<EndChat
						onConfirm={this.endChat}
						comment={this.state.chatEndingComment}
						onCommentChange={this.setChatEndingComment}
						onEndReasonSelect={this.chatEndingReasonSelection}
						onCancel={this.toggleChatEndingModal.bind(this, false)}
					/>
				</Modal>
				<Modal
					title='Release back to queue'
					isOpen={this.state.isReleaseModalOpen}
					onClose={() => {
						this.setState({
							isReleaseModalOpen: !this.state.isReleaseModalOpen,
						});
					}}>
					<ReleaseChat
						onConfirm={this.releaseChat}
						comment={this.state.releaseComment}
						onCommentChange={this.setChatReleaseComment}
						onCancel={this.toggleChatReleaseModal.bind(this, false)}
					/>
				</Modal>
				{/* <Modal
					style={{ zIndex: 10001 }}
					isOpen={this.state.showInvalidate}
					title='Notice'
					onClose={() => {
						this.setState({
							showInvalidate: false,
						});
					}}>
					<div id='session-expiry-wrapper'>
						Your session invalidated. Someone loggedin into your account .
						<Button
							text='Okay'
							theme='dark'
							onClick={() => {
								this.setState({
									showInvalidate: false,
								});
							}}
						/>
					</div>
				</Modal> */}
				<audio id='my_auido' src={require('../assets/audio/light.mp3')} />
				{/* <audio id='my_new_audio' src={require('../assets/audio/queue.mp3')} /> */}
			</div>
		);
	}
}
